var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    _vm.themeMode ? _vm.themeMode : '',
    _vm.screenMode,
    _vm.platfromMode,
    _vm.isIosFlag ? 'iosClient' : 'androidClient',
  ],attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowLoading),expression:"isShowLoading"}],attrs:{"zIndex":11000}}),_c('numberedMode',{directives:[{name:"show",rawName:"v-show",value:(_vm.platfromMode == 'mixtmt_h5'),expression:"platfromMode == 'mixtmt_h5'"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }